export default __webpack_public_path__ + "static/media/Quote-Mark.c3e964ff.svg";